// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {SimMaterialDialogService} from "@services";
import {Event, ISimSession, ParticipantType, SessionState, SimUser} from "@models";

@Component({
	selector: "sim-event-detail-session",
	templateUrl: "./event-detail-session.component.html",
	styleUrls: ["./event-detail-session.component.scss"],
	standalone: false,
})
export class EventDetailSessionComponent {
	ParticipantType = ParticipantType;
	SessionState = SessionState;

	onForwardClicked = output<void>();
	@Input() session: ISimSession;
	@Input() event: Event;
	@Input() showJoinStartActions: boolean = false;
	@Input() showActions: boolean = true;
	@Input() insideDebriefing: boolean = false;
	@Input() sessionStartable: boolean = false;

	constructor(public dialog: SimMaterialDialogService) {}

	public toggle(
		$event: MouseEvent,
		groupedParticipant: {
			users: SimUser[];
			participantType: ParticipantType;
			isOpen: boolean;
			title: string;
		},
	) {
		$event.stopPropagation();

		groupedParticipant.isOpen = !groupedParticipant.isOpen;
	}
}
